// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }
  
  h2 {
    font-size: 3rem;
    font-weight: bold;
    margin-top: 1rem;
    color:#822FA7;
  }
  
  p {
    font-size: 1.5rem;
    margin-top: 1rem;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
    color:#822FA7;
  }
  `, "",{"version":3,"sources":["webpack://./src/app/components/acceso-denegado/acceso-denegado.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,2CAA2C;IAC3C,aAAa;EACf","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n  }\n  \n  h2 {\n    font-size: 3rem;\n    font-weight: bold;\n    margin-top: 1rem;\n    color:#822FA7;\n  }\n  \n  p {\n    font-size: 1.5rem;\n    margin-top: 1rem;\n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);\n    color:#822FA7;\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
